import { GoogleLogout } from 'react-google-login';
import React from 'react';
class Logout extends React.Component{

    
    render(){
        const logout = (re) =>{
            console.log(re);
        }
        return(
        <GoogleLogout
            buttonText="Logout"
            onLogoutSuccess={logout}
            >
            </GoogleLogout>
        )
    }
}

export default Logout;
    


// WEBPACK FOOTER //
// ./src/Logout.js